/**
 * @file ControlAdapter is introduced to partly solve the deprecated support of ngModel with reactive forms.
 * @see https://angular.io/api/forms/FormControlName#use-with-ngmodel
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
/**
 * ControlAdapter is introduced to partly solve the deprecated support of ngModel with reactive forms.
 * Currently used in HorizonComponent.
 * @export
 * @class ControlAdapter
 * @extends {FormControl}
 */
var ControlAdapter = /** @class */ (function (_super) {
    tslib_1.__extends(ControlAdapter, _super);
    /**
     * Creates an instance of ControlAdapter.
     * @param {*} entity The entity used in the binding
     * @param {string} property The property name used in the binding.
     * @param {*} [formState] Initializes the control with an initial value, or an object that defines the initial value and disabled state.
     * @param {(ValidatorFn | ValidatorFn[] | AbstractControlOptions | null)} [validatorOrOpts] A synchronous validator function, or an array of
     * such functions, or an `AbstractControlOptions` object that contains validation functions
     * and a validation trigger.
     * @param {(AsyncValidatorFn | AsyncValidatorFn[] | null)} [asyncValidator] A single async validator or array of async validator functions
     * @memberOf ControlAdapter
     */
    function ControlAdapter(entity, property, formState, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, formState, validatorOrOpts, asyncValidator) || this;
        _this.entity = entity;
        _this.property = property;
        return _this;
    }
    Object.defineProperty(ControlAdapter.prototype, "value", {
        /**
         * Gets the value of the binding
         * @type {*}
         * @memberOf ControlAdapter
         */
        get: function () {
            if (this.entity) {
                return this.entity[this.property];
            }
        },
        /**
         * Sets the value of the binding.
         * @memberOf ControlAdapter
         */
        set: function (val) {
            if (this.entity) {
                this.entity[this.property] = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    return ControlAdapter;
}(FormControl));
export { ControlAdapter };
